import {ComponentProps, ReactNode} from 'react';

import NormalButton from './NormalButton';

type Props = Omit<ComponentProps<typeof NormalButton>, 'left' | 'right'> & {
  settingOne: ReactNode;
  settingTwo: ReactNode;
  toggled: boolean;
  onClick: (toggled: boolean) => void;
};

const ToggleButton = ({toggled, settingOne, settingTwo, ...props}: Props) => {
  return <NormalButton {...props}>{toggled ? settingOne : settingTwo}</NormalButton>;
};

export default ToggleButton;
